import styled from 'styled-components';

export const StyledIcon = styled.img`
  width: 100%;
  max-width: 30px;    
  max-height: 30px;
  
`;
